const registrationTypeIds = {
  open: 1,
  close: 2,
  personalAccount: 3,
  verification: 4,
};

const iconSizes = {
  small: 'small',
  large: 'lg',
};

export { registrationTypeIds, iconSizes };